(() => {
	let accordionCount = 0;

	// Using a function helps isolate each accordion from the others
	function makeAccordion(accordion) {
		const targetsResult = accordion.querySelectorAll('[data-accordion-item]');
		const targets       = [].slice.call(targetsResult);
		const hashMap       = {};

		targets.forEach((accordion) => {
			accordionCount++;
			const target      = accordion.querySelector('.accordion__title');
			const accordionId = target.parentNode.id ? target.parentNode.id : 'info-' + accordionCount;

			hashMap['#' + accordionId] = target.parentNode;

			if (('#' + accordionId) === location.hash) {
				target.parentNode.classList.add('accordion--expanded');
			}

			target.addEventListener('click', () => {
				if (target.parentNode.classList.contains('accordion--expanded')) {
					target.parentNode.classList.remove('accordion--expanded');
					// remove hash
					history.pushState('', document.title, window.location.pathname + window.location.search);
				} else {
					// add hash with pushstate to avoid jump
					history.pushState(null, null, '#' + accordionId);
					target.parentNode.classList.add('accordion--expanded');
				}
			}, false);

			window.addEventListener('hashchange', function (e) {
				if (hashMap[location.hash]) {
					hashMap[location.hash].classList.add('accordion--expanded');
				}
			});

		});
	}

	// Find all the accordions to enable
	const accordions = document.querySelectorAll('[data-accordion]');
	const arr        = [].slice.call(accordions);

	arr.forEach((accordion) => {
		makeAccordion(accordion);
	});
})();